var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({ 
    paddingTop: '5px',
    paddingBottom: '5px',
    display: 'block'
  })},[_c('my-icon-card',{attrs:{"faIcon":!_vm.isLate && _vm.isComplete ? 'check' : _vm.isLate ? 'times' : 'cogs',"data":_vm.processedKeys,"displayKeys":Object.keys(_vm.processedKeys),"color":!_vm.isLate && _vm.isComplete ? '#1FDD00' : _vm.isLate ? '#E74725' : 'tan',"rows":2,"cardWidth":_vm.width || '96%',"altRows":{ 'Job description': 100 },"hideLabels":true,"forceShowLabels":['Job description'],"applyStyles":function (key, index) { return _vm.calculateCardStyles(key, index); },"menu":{
      edit: {
        action: _vm.editInvoiceClick,
        icon: 'pencil-alt',
        color: '#7CFF67',
      },
      print: {
        action: _vm.printItemClick,
        icon: 'print',
        color: '#4ABEFF',
      },
      trash: {
        action: _vm.deleteInvoiceClick,
        icon: 'trash',
        color: 'rgb(255, 127, 127)',
      },
    }},scopedSlots:_vm._u([{key:"funds",fn:function(){return [_c('ul',{staticClass:"card-slot-funds"},[_c('li',{staticClass:"dollar-sign"},[_c('p',[_vm._v("$")])]),_c('li',{staticClass:"amount"},[_c('p',[_vm._v(_vm._s(_vm.fMon(_vm.info.owe)))])]),_c('li',{staticClass:"amount"},[_c('p',[_vm._v(_vm._s(_vm.fMon(_vm.info.paid)))])]),_c('li',{staticClass:"amount"},[_c('p',[_vm._v(_vm._s(_vm.fMon(_vm.balance)))])])])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }